module.exports = __webpack_public_path__ + "img/70.b965b03e.png";